<template>
    <div  style="margin-top: 20px;text-align: right;">
        <el-pagination  
                  background 
                  @size-change="handleSizeChange" 
                  @current-change="handleCurrentChange" 
                  :current-page="currentPage"
                  :page-sizes="[10, 50, 100, 500,1000]" 
                  :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper" 
                  :total="total">
        </el-pagination>
    </div>
</template>
<script>
export default {
      props: {
         total: Number,
      },
      data() {
      return {
        currentPage: 1,//当前页数
        pageSize: 10,//每页显示条目个数
      };
    },
       methods: {
        handleSizeChange(val) {
           this.pageSize = val;
           this.currentPage = 1;
           this.$emit('transferName', {pageSize: this.pageSize, current: this.currentPage});
         },
        handleCurrentChange(val) {
           this.current = val;
           this.$emit('transferName', {pageSize: this.pageSize, current: val});
      },
    }
  }
</script>